import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab'];
  static values = { targetId: String };

  connect() {
    console.log('Tab Toggle controller connected');
    this.currentTab = document.querySelector('.active-square-tab');
    this.onFrameLoad = this.onFrameLoad.bind(this); // Bind the method to ensure 'this' context
    document.addEventListener('turbo:frame-load', this.onFrameLoad);
  }

  onFrameLoad(event) {
    // console.log('event happens', event.target);
    if (event.target.id === this.targetIdValue) {
      // console.log('correct event!');
      this.updateActiveTab();
    }
  }

  handleClick(event) {
    this.currentTabId = event.currentTarget.querySelector('div').id;
  }

  updateActiveTab() {
    if (this.currentTabId) {
      const newTab = document.getElementById(this.currentTabId);
      if (newTab) {
        if (this.currentTab) {
          this.tabTargets.forEach((tab) => {
            tab.classList.remove('active-square-tab');
          });
        }
        this.currentTab = newTab;
        newTab.classList.add('active-square-tab');
      }
    }
  }

  disconnect() {
    document.removeEventListener('turbo:frame-load', this.onFrameLoad);
  }
}
